import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

export default injectIntl((props) => {
  // console.log(props);
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: (
            <div
              style={{ textAlign: "center", color: "blue", fontWeight: "bold" }}
            >
              <IntlMessages id="table.import.success" />: {props.data.length} -{" "}
              <span
                style={{
                  textAlign: "center",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                <IntlMessages id="table.import.failed" />:{" "}
                {props.dataFailed.length}
              </span>
            </div>
          ),
          columns: [
            {
              Header: <IntlMessages id="stock.name" />,
              accessor: "name",
              minWidth: 250,
            },
            {
              Header: <IntlMessages id="table.import.sku" />,
              accessor: "sku",
            },
            {
              Header: <IntlMessages id="table.import.barcode" />,
              accessor: "barcode",
            },
            {
              Header: <IntlMessages id="pages.category" />,
              accessor: "category",
            },
            {
              Header: <IntlMessages id="table.import.recommend" />,
              accessor: "bestter",
            },
            {
              Header: <IntlMessages id="product.price" />,
              accessor: "price",
            },
            {
              Header: <IntlMessages id="product.promotion-price" />,
              accessor: "price_sale",
            },
            {
              Header: <IntlMessages id="table.import.apply_promotion" />,
              accessor: "active_sale",
            },
            {
              Header: <IntlMessages id="table.import.image" />,
              accessor: "image",
            },
            {
              Header: <IntlMessages id="table.import.hidden" />,
              accessor: "softHide",
            },
          ],
        },
      ],
    });
  }, []);

  return (
    <ReactTable
      defaultPageSize={10}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
});
